import { render, staticRenderFns } from "./SignupVerification.vue?vue&type=template&id=6144b0a1&scoped=true"
import script from "./SignupVerification.vue?vue&type=script&lang=js"
export * from "./SignupVerification.vue?vue&type=script&lang=js"
import style0 from "./SignupVerification.vue?vue&type=style&index=0&id=6144b0a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6144b0a1",
  null
  
)

export default component.exports